export const React = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clip-path="url(#clip0_2967_809)">
        <path
          d="m250.504 284.862c270.046 284.862 285.889 269.029 285.889 249.499c285.889 229.968 270.046 214.136 250.504 214.136c230.961 214.136 215.119 229.968 215.119 249.499c215.119 269.029 230.961 284.862 250.504 284.862z"
          fill="currentColor"
        />
        <path
          d="m250.501 321.96c355.363 321.96 440.371 289.522 440.371 249.509c440.371 209.495 355.363 177.058 250.501 177.058c145.639 177.058 60.6318 209.495 60.6318 249.509c60.6318 289.522 145.639 321.96 250.501 321.96z"
          stroke="currentColor"
          stroke-width="18.913"
        />
        <path
          d="m187.724 285.725c240.155 376.482 310.768 433.837 345.442 413.83c380.116 393.823 365.721 304.031 313.29 213.274c260.859 122.517 190.247 65.1621 155.572 85.1689c120.898 105.176 135.293 194.968 187.724 285.725z"
          stroke="currentColor"
          stroke-width="18.913"
        />
        <path
          d="m187.726 213.277c135.295 304.034 120.9 393.826 155.574 413.833c190.248 433.84 260.861 376.485 313.292 285.728c365.723 194.971 380.118 105.179 345.443 85.172c310.769 65.1652 240.157 122.52 187.726 213.277z"
          stroke="currentColor"
          stroke-width="18.913"
        />
      </g>
      <defs>
        <clipPath id="clip0_2967_809">
          <rect
            width="397"
            height="353"
            fill="currentColor"
            transform="translate(52 73)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
